import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slice/authSlice";
import modalAlertReducer from "./slice/modalSlice";
import loadingReducer from "./slice/loadingSlice";
import membershipReducer from "./slice/membershipSlice";
import routeReducer from "./slice/routeSlice";
import searchPlaceReducer from "./slice/searchPlaceSlice";
import userReducer from "./slice/userSlice";
import communitiesReducer from "./slice/communitiesSlice";
import runningsClubsReducer from "./slice/runningsClubsSlice";
import patientsReducer from "./slice/patientsSlice";
import specialistReducer from "./slice/specialistSlice";
import badgeReducer from "./slice/badgeSlice";

const persistConfig = {
  key: "root",
  storage,
};

const combinedReducers = combineReducers({
  authReducer,
  modalAlertReducer,
  loadingReducer,
  membershipReducer,
  routeReducer,
  searchPlaceReducer,
  userReducer,
  communitiesReducer,
  patientsReducer,
  runningsClubsReducer,
  specialistReducer,
  badgeReducer,
});

const persistedReducer = persistReducer(persistConfig, combinedReducers);

const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
